import $ from 'cash-dom';

/**
 * This module open/closes the mobile menu and submenus
 */
export class HeaderModule {

    static name = 'header';

    constructor(node) {

        this.node = node;

        this.initJumplinks();
        this.initToggle();
    }

    initJumplinks() {

        $(this.node)
        .find('a[href*="#"]:not([target="_blank"])')
        .add('a.footer-link[href*="#"]:not([target="_blank"])')
        .on('click', (e) => {
            const hash = e.currentTarget.href.split('#')[1];
            const target = $(`a[name="${hash}"]`);
            if(target.length) {
                e.preventDefault();
                target[0].scrollIntoView({ behavior: 'smooth' });
                this.close();
            }            
        });
    }

    initToggle() {
        const $header = $(this.node);
        $header.find('.header-toggle').on('click', () => {
            if($header.hasClass('open')) {
                this.close();
            } else {
                this.open();
            }
        });
    }

    open() {
        $(this.node).addClass('open');
        $('body').addClass('overflow-hidden');
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    close() {
        $(this.node).removeClass('open');
        $('body').removeClass('overflow-hidden');
    }
}